@import "../../containers/styles.module.scss";

.container {
  padding-bottom: 4rem;

  &__form_group {
    & > label {
      font-size: 20px;
      font-weight: bold;
    }
  }
}

.btn_backToMyAccount {
  @media (min-width: $size-sm) {
    width: 175px !important;
  }
}